var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscountShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#00CEBC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m6.982 25.656-2.66-2.66a2.81 2.81 0 0 1 0-3.955l2.66-2.66c.455-.455.822-1.347.822-1.977V10.64c0-1.54 1.26-2.8 2.8-2.8h3.763c.63 0 1.522-.367 1.977-.822l2.66-2.66a2.81 2.81 0 0 1 3.955 0l2.66 2.66c.455.455 1.348.822 1.977.822h3.763c1.54 0 2.8 1.26 2.8 2.8v3.763c0 .63.367 1.522.822 1.977l2.66 2.66a2.81 2.81 0 0 1 0 3.955l-2.66 2.66c-.455.455-.822 1.348-.822 1.978v3.762c0 1.54-1.26 2.8-2.8 2.8h-3.763c-.63 0-1.522.368-1.977.823l-2.66 2.66a2.81 2.81 0 0 1-3.955 0l-2.66-2.66c-.455-.455-1.348-.823-1.978-.823h-3.762c-1.54 0-2.8-1.26-2.8-2.8v-3.762c0-.648-.367-1.54-.822-1.978M15.75 26.25l10.5-10.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00CEBC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M25.365 25.375h.016M16.615 16.625h.016"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountShape);
export default __webpack_public_path__ + "static/media/discountShape.d26b0438026334d610e929661b2d806a.svg";
export { ForwardRef as ReactComponent };